export const CICLOS_VIDA_BASE = ['Ajuste', 'Limpeza', 'Manutenção', 'Operação Normal'];
export const TIPOS_PERIGO = [
  'Mecânico',
  'Elétrico',
  'Térmico',
  'Ruído',
  'Vibração',
  'Radiação',
  'Químico',
  'Ergonômico',
  'Ambiental',
  'Combinação',
];

